import type { IRunPlan, IScaffold } from '../types';
import { logInfo } from '../services/log';
import { Scaffold } from './scaffold';

/**
 * render an `<section>` as the scaffold to load a remote view into
 */
export class RegionScaffold extends Scaffold implements IScaffold {
  /**
   * create a section tag to render the remote view into
   */
  async create(runPlan: IRunPlan) {
    const defaultAttrs = {};
    const regionTag = runPlan.scaffold.region_tag;
    const sectionEl = document.createElement(regionTag);

    return this._mergeAttributes(sectionEl, runPlan, defaultAttrs);
  }

  /**
   * find and erase the section tag created in startup
   */
  async destroy(runPlan: IRunPlan, renderTo: HTMLElement) {
    renderTo.innerHTML = '';
  }

  /**
   * a section will only render the body and not the head or index because
   * there is already a `<head>` on the page
   */
  async weaveCode(head: string, body: string, index: string) {
    return body;
  }

  /**
   * we can only render HTML tags into a section
   */
  async injectCode(scaffoldEl: HTMLElement, code: string) {
    scaffoldEl.innerHTML = code;
  }

  /**
   * the context is the section element
   */
  async computeScriptContext<E extends HTMLElement>(scaffoldEl: E): Promise<HTMLElement> {
    return scaffoldEl;
  }

  /**
   * there is no action before we mount
   */
  async beforeMount(scaffoldEl: HTMLElement, renderTo: HTMLElement, runPlan: IRunPlan) {
    return;
  }

  /**
   * after we mount we should run the mount function
   */
  async afterMount(scaffoldEl: HTMLElement, renderTo: HTMLElement, runPlan: IRunPlan) {
    if (runPlan.mount) {
      await runPlan.mount(scaffoldEl, renderTo as HTMLElement);
      logInfo(renderTo, `run mount`);
    }
  }
}
